import React from 'react'
import styled from 'styled-components'

import './index.scss'
import Layout from '../components/Layout/Layout'
import homeGif from '../assets/home.gif'
import homeMobileGif from '../assets/home-mobile.gif'

const Animation = styled.img`
  width: 100%;
  max-width: 1000px;
  content: url(${homeMobileGif});

  @media (min-width: 576px) {
    content: url(${homeGif});
  }
`

const IndexPage = ({ pathContext: { locale } }) => (
  <Layout locale={locale}>
    <div>
      <Animation />
    </div>
  </Layout>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js